import React from 'react';
import {request} from '../helpers/request'
import jQuery from 'jquery'
import ModalComponent from './common/ModalComponent'
import LoadingComponent from './common/LoadingComponent'
import {browserHistory} from 'react-router'
import {t} from '../helpers/translate'
import {getPortal} from '../helpers/access'
import { mask } from '../helpers/common';
import PasswordComponent from './common/PasswordComponent';
let config = require('config');

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      resetEmail: '',
      mfa: '',
      mfa_id: '',
      username: '',
      password: '',
      showMfaModal: false,
      showPasswordResetModal: false,
      showErrorModal: false,
      hasError: false,
      modalMessage: false,
      loading: false,
      mfaError: null,
      verifying: false,
    };
    const root = document.documentElement;
    root.style.setProperty("--msh-orange", "#D83D17");
    if (this.isLoggedIn()) {
      window.location.pathname = '/home'
    }

    sessionStorage.removeItem('microsite_colour');
  }

  isLoggedIn() {
    return sessionStorage.getItem('auth') != null && sessionStorage.getItem('org') != null
  }

  getMfaId() {
    return localStorage.getItem('mfa_id');
  }

  handleModalClose() {
    this.setState({
      showMfaModal: false,
      showPasswordResetModal: false,
      showErrorModal: false,
    })
  }

  handleResetEmailChange(event) {
    this.setState({resetEmail: event.target.value})
  }

  handleMfaChange(event) {
    this.setState({mfa: event.target.value})
  }

  sendPasswordResetEmail() {
    jQuery.ajax(
      {
        url: `${config.default.auth_base_api}/auth/forgotpassword/request`,
        method: 'POST',
        data: {
          email: this.state.resetEmail.replaceAll(' ', ''),
          org: getPortal()
        }
      }
    ).always((response, statusText) => {
      if (statusText == 'success') {
        this.setState({
          showPasswordResetModal: false,
          hasError: true,
          modalMessage: t('A password reset link has been sent to your email.'),
          showErrorModal: true
        })
      } else {
        this.setState({
          hasError: true,
          modalMessage: t('Your request could not be processed. Please try again.'),
          showErrorModal: true
        })
      }
    });
  }

  sendMfaVerification() {
    this.setState({ mfaError: null, verifying: true })

    const data = {
      mfa_code: this.state.mfa.replaceAll(' ', ''),
      mfa_id: this.state.mfa_id,
    }

    request(`${config.default.auth_base_api}/auth/mfa/verify`, 'POST', data, (responseData, statusCode) => {
      if (statusCode === 200) {
        sessionStorage.setItem('auth', 'Bearer' + ' ' + responseData['access_token']);
        if(responseData['mfa_id']){
          localStorage.setItem('mfa_id', responseData['mfa_id']);
        }
        this.getMeAndRedirect();
      } else {
        this.setState({
          mfaError: responseData.messages[0] || 'Error',
          verifying: false,
        })
      }
    })
  }

  handleUsernameChange(event) {
    this.setState({username: event.target.value})
  }

  handlePasswordChange(event) {
    this.setState({password: event.target.value})
  }

  handleKeyPress(event) {
    if (event.key == 'Enter') this.getAccessToken()
  }

  showPasswordResetModal() {
    this.setState({
      showPasswordResetModal: true
    })
  }

  getAccessToken() {
    this.setState({loading: true});

    const data = {
      email: this.state.username,
      password: this.state.password,
      org: getPortal(),
      mfa_id: this.getMfaId(),
    }

    request(`${config.default.auth_base_api}/token/travel/user`, 'POST', data, (response, statusCode) => {
      this.setState({loading: false})
      if (statusCode == 200) {
        if (response['mfa_required'] && response['mfa_id']) {
          this.setState({
            mfa_id: response['mfa_id'],
            hasError: true,
            modalMessage: t('Enter MFA'),
            showMfaModal: true,
            mfaError: null,
          })
          localStorage.setItem('mfa_id', responseData['mfa_id']);
        } else {
          sessionStorage.setItem('auth', 'Bearer' + ' ' + response['access_token']);
          this.getMeAndRedirect();
        }
      } else {
        this.setState({
          hasError: true,
          modalMessage: t('Invalid username and/or password.'),
          showErrorModal: true
        })
      }
    });
  }

  verifyScope(authLevel, responseScopes) {
    return responseScopes.some(elem => config.default.scopes[authLevel].includes(elem))
  }

  setSessionAuthLevel(authLevel, responseScopes){
    if(this.verifyScope(authLevel, responseScopes)){
      sessionStorage.setItem('auth_level', authLevel);
    }
    return true;
  }

  getMeAndRedirect() {
    request(`${config.default.auth_base_api}/me`, 'GET', {}, (responseData, statusCode) => {
      if (statusCode === 200) {
        if (responseData.data.csr_token) {
          sessionStorage.setItem('user_id', responseData.id)
          sessionStorage.setItem('csr_token', responseData.data.csr_token)
          sessionStorage.setItem('wfg_user', responseData.data.wfg_user)
          sessionStorage.setItem('org', responseData.org)
          sessionStorage.setItem('school', responseData.data.school)
          responseData.data.all_schools && sessionStorage.setItem('all_schools', responseData.data.all_schools)
          sessionStorage.setItem('scopes', responseData.scopes)
          sessionStorage.setItem('access_level', responseData.access_level)
          sessionStorage.setItem('me', `${responseData.first_name} ${responseData.last_name}`)
          sessionStorage.setItem('first_name', responseData.first_name)
        }
        this.setSessionAuthLevel('readonly', responseData.scopes);
        this.setSessionAuthLevel('agent', responseData.scopes);
        this.setSessionAuthLevel('schooladmin', responseData.scopes);
        this.setSessionAuthLevel('schoolsuperadmin', responseData.scopes);
        this.verifyScope('viewonly', responseData.scopes) && sessionStorage.setItem('access_level', 'viewonly');
        this.setSessionAuthLevel('admin', responseData.scopes);
        this.setSessionAuthLevel('superadmin', responseData.scopes);
        this.setSessionAuthLevel('masteradmin', responseData.scopes);
        this.setSessionAuthLevel('pmoadmin', responseData.scopes);
      }
      browserHistory.push('/home');
    })
  }

  getPasswordResetModalBody () {
    return <div>
      <div className="col-md-12">
        <input placeholder="email" type="text" name="login"
               onChange={this.handleResetEmailChange.bind(this)} className="form-control"/>
        <br />
        <button onClick={this.sendPasswordResetEmail.bind(this)} type="button" className="btn btn-lg button-primary center-block">
          {t('Request Password Reset')}
        </button>
      </div>
    </div>
  }

  getMfaModalBody () {
    return <div>
      <div className="col-md-12">
        <p
          dangerouslySetInnerHTML={{
            __html: t(
              'We have sent a verification code to your email address %s, this code will remain valid for 10 minutes. Enter the code below to log in to your Admin Dashboard.',
               `<strong>(${mask(this.state.username, 2)})</strong>`
            )
          }}
        />
        <p>{t('If you did not receive a verification code, please log in again to prompt us to send you another verification code')}.</p>
        <input placeholder="MFA" type="text" name="login"
               onChange={this.handleMfaChange.bind(this)} className="form-control"/>
        <br />
        {this.state.mfaError && <p className="cancellation-error">{this.state.mfaError}</p>}
        <button onClick={this.sendMfaVerification.bind(this)} type="button" className="btn btn-lg button-primary center-block">
          {t('Verify MFA')}
        </button>
      </div>
    </div>
  }

  displayLogo() {
    const logo = (config.default.domains[location.hostname] || config.default.domains['default']).logo
    const logoUrl = `https://s3.ca-central-1.amazonaws.com/msh-assets/insurance/${logo}_${t('en')}.png`;
    return <img src={logoUrl} size="lg" />
  }

  displaySchoolLogo() {
    return
  }

  getLogosClass() {
    return 'login-logos';
  }

  render() {
    return <div className="container">
      <div className="text-center bg-inherit">
        <h2 className={this.getLogosClass()}>{this.displaySchoolLogo()}&nbsp;{this.displayLogo()}</h2>
      </div>
      <div className={`form-group-lg ${this.state.hasError ? 'has-error' : ''}`}>
        <div className="row">
          <div className="col-md-3">
          </div>
          <div className="col-md-6">
            <input
              placeholder={t("Username / Email")}
              type="text"
              name="login"
              onChange={this.handleUsernameChange.bind(this)}
              className="form-control"
            />
            <br />
            <PasswordComponent
              handleKeyPress={this.handleKeyPress.bind(this)}
              type={"login"}
              placeholder={t("Password")}
              editMode
              onDataChanged={({ _, value }) => {
                this.setState({ password: value });
              }}
            />
          </div>
        </div>
        <br />
        <button onClick={this.getAccessToken.bind(this)} type="button" className="btn btn-lg button-secondary center-block">
          {t('sign in')}
        </button>
        <br />
        <button onClick={this.showPasswordResetModal.bind(this)} type="button" className="btn btn-lg button-primary center-block">
          {t('Forgot Password')}
        </button>

        <ModalComponent
          title="Reset Password"
          body={this.getPasswordResetModalBody()}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showPasswordResetModal}
        />

        <ModalComponent
          title={t("Multi-Factor Authentication Verification")}
          body={this.getMfaModalBody()}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showMfaModal}
        />

        <ModalComponent
          body={this.state.modalMessage}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showErrorModal}
        />

        <LoadingComponent show={this.state.loading} text={t('Signing In')}/>
        <LoadingComponent show={this.state.verifying} text={t('Validating MFA')}/>

      </div>
    </div>
  }
}

Login.defaultProps = {};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js